import React from "react";
import T from "prop-types";
import { translateProps } from "MODULES/shared/decorators";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { StatusTag } from "MODULES/shared/components";

export function ExportComplianceHold({ hold }) {
  return hold && <StatusTag title="Export Compl Hold" icon="pause" />;
}

ExportComplianceHold.propTypes = { hold: T.bool.isRequired };

const withProps = translateProps(({ lineItems }) => ({
  hold: lineItems
    .filter(l => !l.cancelled)
    .filter(l => !l.shipped)
    .some(i => i.export_compliance_hold)
}));

export default withSalesOrder(withProps(ExportComplianceHold));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Warnings/ExportComplianceHold.jsx